import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminOrders from "../../Components/Admin/AdminOrders";
import AdminSideBar from "../../Components/Admin/AdminSideBar";
import SideBar from "../../Components/Admin/SideBar";
import Pagination from "../../Components/Utilities/Pagination";

const AdminOrdersPage = () => {
  return (
    <div className="d-flex justify-content-start">
      <div>
        <SideBar />
      </div>
      <div className="p-4" style={{ width: '100%' }}>
        <AdminOrders />
      </div>
    </div>
  );
};

export default AdminOrdersPage;
